<template>
  <div>
    <div>
      <v-btn ref="btnVoltar" icon @click="voltar()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
    </div>
    <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;">
      <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>
    <v-card class="pa-3 mt-3">
      <form class="notificacao" @submit.prevent="onSubmit">
        <Input type="text" :label="acao == 'novo' ? 'Código da Notificação' : 'Código da Notificação*'" disabled v-model="form.identificadornotificacao" />
        <Select :disabled="loading || acao != 'novo'" :options="anoLetivoOptions" v-model="form.aaletivo" label="Ano Letivo*" :v="$v.form.aaletivo" @change="$refs.turmas.limpar()"/>
        <select-ajax
          label="Turma"
          :disabled="loading || acao != 'novo'  || form.aaletivo == ''"
          rota='ei/turma/select-turmas-perfil'
          :params="{ cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdpessoal:form.cdpessoalautor, cdmatric:form.cdmatricautor, aaletivo:form.aaletivo, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          :listaLocal="notificacao ? [{ value: notificacao.turma.nmturma, key: notificacao.turma.cdturma}] : null"
          contador
          ref="turmas"
          chave="cdturma"
          :valor="(item) => `${item.nmturma} ${item.horario ? ' - ' + item.horario : ''}`"
          v-model="form.cdturma"
          :v="$v.form.cdturma"
          @change="$refs.disciplinas.limpar(); $refs.periodos.limpar();">
        </select-ajax>
        <select-ajax
          label="Disciplina/Campo de Experiência"
          :disabled="loading || acao != 'novo' || form.cdturma == ''"
          rota='ei/disciplina/select-disciplinas-perfil-periodo'
          :params="{ cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdpessoal:form.cdpessoalautor, cdmatric:form.cdmatricautor, aaletivo:form.aaletivo, cdturma:form.cdturma, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
          :resultado='["disciplinas"]'
          :listaLocal="notificacao ? [{ value: notificacao.disciplina.dsdiscipl, key: notificacao.disciplina.cddiscipl}] : null"
          contador
          ref="disciplinas"
          chave="cddiscipl"
          valor="dsdiscipl"
          v-model="form.cddiscipl"
          :v="$v.form.cddiscipl"
          @change="$refs.professores.limpar()">
        </select-ajax>
        <select-ajax
            label="Período Avaliativo"
            :disabled="loading || acao != 'novo' || form.cdturma == ''"
            rota='ei/disciplina/select-disciplinas-perfil-periodo'
            :params="{ cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdpessoal:form.cdpessoalautor, cdmatric:form.cdmatricautor, aaletivo:form.aaletivo, cdturma:form.cdturma, identificadorperfilatual:userDadosPerfilAtual.identificadorperfil }"
            :resultado='["periodos"]'
            :listaLocal="notificacao ? notificacao.periodo_avaliativo ? [{ value: notificacao.periodo_avaliativo.dspravadi, key: notificacao.periodo_avaliativo.cdpravadi}] : (form.cdpravadi = '-1', [ { value: 'Todos', key: '-1' } ]) : null"
            contador
            opcaoTodos="Todos"
            ref="periodos"
            chave="cdpravadi"
            valor="dspravadi"
            v-model="form.cdpravadi"
            :v="$v.form.cdpravadi">
          </select-ajax>
        <Select :options="optionsAutor" disabled v-model="form.cdmatricautor" label="Autor*" :v="$v.form.cdmatricautor"/>
        <select-ajax
            label="Atribuído"
            :disabled="loading || acao != 'novo' || form.cddiscipl == ''"
            rota='ei/professor/select-professor-por-turma-disciplina'
            :params="{ aaletivo:form.aaletivo, cdtipesc:form.cdtipesc, cdescola:form.cdescola, cdturma:form.cdturma, cddiscipl:form.cddiscipl }"
            :listaLocal="notificacao ? [ {value: `${notificacao.professor.cdmatric} - ${notificacao.professor.nmfuncion}`, key: notificacao.professor.cdpessoal + '-' + notificacao.professor.cdmatric} ] : null"
            contador
            ref="professores"
            :chave="(item) => `${item.cdpessoal}-${item.cdmatric}`"
            :valor="(item) => `${item.cdmatric} - ${item.nmfuncion}`"
            v-model="atribuido"
            :v="$v.form.cdmatricatribuido">
          </select-ajax>
        <TextArea :disabled="loading || acao == 'readOnly' || tipoPerfil == '2'" style="margin-bottom: 17px" rows=5 v-model="form.descricaonotificacao" label="Descrição da Notificação" :v="$v.form.descricaonotificacao"/>
        <Validator style="margin-bottom: 25px" label="Situação" :v="$v.form.indicasituacaonotificacao">
          <Radio disabled label="Pendente" v-model="form.indicasituacaonotificacao" val="P" />
          <Radio disabled label="Resolvido" v-model="form.indicasituacaonotificacao" val="R" />
        </Validator>
        <InputDate :disabled="loading || acao == 'readOnly' || tipoPerfil == '2'" v-model="form.dataexibicao" label="Data de Exibição" :v="$v.form.dataexibicao"/>
        <TextArea :disabled="loading || acao == 'readOnly' || tipoPerfil == '8'" style="margin-bottom: 25px" rows=5 v-model="form.descricaoresposta" label="Descrição da Resposta" :v="$v.form.descricaoresposta"/>
        <InputDate disabled v-model="form.dataresposta" label="Data da Resposta" :v="$v.form.dataresposta"/>
        <div class="mt-3 text-xs-right text-right">
          <v-btn :disabled="acao == 'readOnly'" type="submit" :loading="loading" small color="teal" class="white--text rounded-sm font-weight-regular">Salvar</v-btn>
        </div>
      </form>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store/index';
import { mapGetters } from 'vuex';
import { required, integer, maxLength } from 'vuelidate/lib/validators';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import SelectAjax from '@/components/SelectAjax'

const NotificacaoRepository = RepositoryFactory.get('notificacao');

moment.locale('pt-br');

const maiorOuIgual = (value) => moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD');

const setFormInicial = () => ({
  identificadornotificacao: '',
  aaletivo: '',
  cdtipesc: '',
  cdescola: '',
  cdturma: '',
  cddiscipl: '',
  cdpravadi: '',
  cdpessoalautor: '',
  cdmatricautor: '',
  cdpessoalatribuido: 1,
  cdmatricatribuido: '',
  descricaonotificacao: '',
  indicasituacaonotificacao: 'P',
  dataexibicao: '',
  descricaoresposta: '',
  dataresposta: '',
});

export default {
  name: 'registro-notificacao-cadastro',

  components: {
    SelectAjax
  },

  props: {
    id: [Number, String],
  },

  data() {
    return {
      acao: '',
      form: setFormInicial(),
      msgArrayError: [],
      snackbar: false,
      submitText: '',
      loading: false,
      anoLetivoOptions: [],
      optionsAutor: [],
      tipoPerfil: '',
      notificacao: null
    };
  },

  validations() {
    if ( this.professorLogado() ) {
      return {
        form: {
          aaletivo: { required, integer },
          cdtipesc: { required, integer },
          cdescola: { required, integer },
          cdturma: { required, maxLength: maxLength(4) },
          cddiscipl: { required, integer },
          cdpravadi: { maxLength: maxLength(2) },
          cdpessoalautor: { required, integer },
          cdmatricautor: { required, integer },
          cdpessoalatribuido: { required, integer },
          cdmatricatribuido: { required, integer },
          descricaonotificacao: { required, maxLength: maxLength(500) },
          indicasituacaonotificacao: { required },
          dataexibicao: { required, isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
          descricaoresposta: { required, maxLength: maxLength(500), isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
          dataresposta: { required },
        }
      };
    }
    else {
      return {
        form: {
          aaletivo: { required, integer },
          cdtipesc: { required, integer },
          cdescola: { required, integer },
          cdturma: { required, maxLength: maxLength(4) },
          cddiscipl: { required, integer },
          cdpravadi: { maxLength: maxLength(2) },
          cdpessoalautor: { required, integer },
          cdmatricautor: { required, integer },
          cdpessoalatribuido: { required, integer },
          cdmatricatribuido: { required, integer },
          descricaonotificacao: { required, maxLength: maxLength(500) },
          indicasituacaonotificacao: { required },
          dataexibicao: { required, maiorOuIgual,  isValidDate: (value) => moment(value, 'DD/MM/YYYY').isValid() },
          descricaoresposta: { },
          dataresposta: { },
        }
      };
    }
  },

  async beforeRouteEnter(to, from, next) {
    try{
      let tipoPerfil = store.getters.userDadosPerfilAtual.identificadorperfil;
      let notificacao = {};

      if ( to.params.id ) {
        if ( tipoPerfil == 8 )
          notificacao = await NotificacaoRepository.getNotificacao( to.params.id, { cdtipesc: store.getters.school.cdtipesc, cdescola: store.getters.school.cdescola, cdmatricautor: store.getters.userProfessor.cdmatric, cdpessoalautor: store.getters.userProfessor.cdpessoal } );
        else if ( tipoPerfil == 2 )
          notificacao = await NotificacaoRepository.getNotificacao( to.params.id, { cdtipesc: store.getters.school.cdtipesc, cdescola: store.getters.school.cdescola, cdmatricatribuido: store.getters.userProfessor.cdmatric, cdpessoalatribuido: store.getters.userProfessor.cdpessoal } );
      }

      next(vm => {
        if ( to.params.id ) {
          vm.editaNotificacao( notificacao.data );
        } else {
          if (tipoPerfil == 8 )
            vm.novaNotificacao();
          else
            next('/registro-notificacao');
        }
      });
    }
    catch( e ) {
      next('/registro-notificacao');
    }
  },

  async mounted() {
    this.$Progress.finish();

    this.form.cdtipesc = this.school.cdtipesc;
    this.form.cdescola = this.school.cdescola;
    this.form.cdpessoalautor = this.userProfessor.cdpessoal;
    this.form.cdmatricautor = this.userProfessor.cdmatric;
    this.tipoPerfil = this.userDadosPerfilAtual.identificadorperfil;
  },

  methods: {
    async novaNotificacao() {
      this.acao = 'novo';
      this.loadAnos();
      this.form.aaletivo = this.getAnoAtualServidor;

      this.form.cdmatricautor = this.userProfessor.cdmatric;
      this.optionsAutor = [ { text: `${this.userProfessor.cdmatric} - ${this.username}`, value: this.form.cdmatricautor} ];

      this.form.dataexibicao = moment().format('DD/MM/YYYY');

      this.$v.$reset();
    },

    async editaNotificacao( notificacao ) {
      if ( notificacao.indicasituacaonotificacao == 'R' ) {
        this.acao = 'readOnly';
      }

      this.notificacao = notificacao;

      this.form = { ...notificacao };
      this.form.dataexibicao = moment(notificacao.dataexibicao, 'YYYY-MM-DD').format('DD/MM/YYYY');
      this.form.dataresposta = moment(notificacao.dataresposta, 'YYYY-MM-DD').format('DD/MM/YYYY');

      if (notificacao.cdpravadi == null) this.form.cdpravadi = '-1';

      this.anoLetivoOptions = [ {text: notificacao.aaletivo, value: notificacao.aaletivo} ];
      this.optionsAutor = [ {text: `${notificacao.coordenador.cdmatric} - ${notificacao.coordenador.nmfuncion}`, value: notificacao.coordenador.cdmatric} ];

      if ( this.professorLogado() ) {
        this.form.indicasituacaonotificacao = 'R';
        this.form.dataresposta = moment().format('DD/MM/YYYY');
      }
    },

    async onSubmit() {

      this.$v.$touch();

      if (this.$v.$invalid) {
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }

        return;
      }

      try {
        this.loading = true;

        this.trocarCdpravadi();
        const form = {...this.form};
        form.dataexibicao = moment(this.form.dataexibicao, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const funcao = ( this.acao == 'novo') ? 'post' : 'put';
        const { data } = await NotificacaoRepository[`${funcao}Notificacao`](form);

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        if ( this.acao == 'novo')
          setTimeout(() => { this.$root.$router.push({ path: '/registro-notificacao', }); }, 1000);
        else
          setTimeout(() => { this.$root.$router.push( { name: 'registro-notificacao', params: { restaurar:true, notificacao:this.form } } ); }, 1000 );

        this.acao = '';

        if ( this.professorLogado() ) {
          this.$emit('update-notification', 'true');
        }

      } catch (error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
        if (window.scrollY >= 250) { window.scrollTo({ top: 0, behavior: 'smooth' }); }

      } finally {
        this.loading = false;
      }
    },

    loadAnos() {
      if (!this.getAnoInicioSistema || !this.getAnoAtualServidor) { return []; }

      this.anoLetivoOptions = [];

      for ( let i = this.getAnoAtualServidor; i >= this.getAnoInicioSistema; i-- ) {
        this.anoLetivoOptions.push({ text: i, value: i });
      }
    },

    professorLogado() {
      return this.tipoPerfil == 2;
    },

    trocarCdpravadi() {
      if (this.form.cdpravadi == '-1') this.form.cdpravadi = null;
    },

    voltar() {
      if (this.acao != 'novo') {
        this.form.indicasituacaonotificacao = this.notificacao.indicasituacaonotificacao;
        this.form.dataresposta = this.notificacao.dataresposta;
      }
      this.$root.$router.push({ name: 'registro-notificacao', params: { restaurar:this.acao != 'novo', notificacao:this.form } });
    },
  },

  computed: {
    ...mapGetters(['getAnoSistema', 'getAnoAtualServidor', 'getAnoInicioSistema', 'userProfessor', 'school', 'username', 'userDadosPerfilAtual']),
    atribuido: {
      get() {
        return this.form.cdmatricatribuido == -1 ? this.form.cdmatricatribuido : `${this.form.cdpessoalatribuido}-${this.form.cdmatricatribuido}`;
      },
      set(value) {
        if (value === -1 || value === "") {
          this.form.cdpessoalatribuido = '';
          this.form.cdmatricatribuido = value;
          return;
        }
        [this.form.cdpessoalatribuido, this.form.cdmatricatribuido] = value.split('-');
      }
    }
  }
};
</script>

<style lang="scss">

@media only screen and (min-width: 700.1px){
  .notificacao .select-ajax {
    .selecionado { width: 60%; }
    .select-ajax-lista { width: 60%; }
  }
}
</style>
